module.exports = __webpack_public_path__ + "img/ab-page4-xa.e096195e.png";